
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mieten/standorte/[...slug]",
      function () {
        return require("private-next-pages/mieten/standorte/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mieten/standorte/[...slug]"])
      });
    }
  